import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@iupics-config/app.config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResourceAccessService {
  private accessURL: string;

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {}

  /**
   * @returns null = no access, false = read-only access, true = read/write access.
   */
  getAccess(type: string, id: number): Observable<boolean | null> {
    if (this.accessURL === undefined) {
      this.accessURL = this.config.getBackendResource('resourceAccess');
    }
    return this.http.get<boolean | null>(`${this.accessURL}/${id}?type=${type}`);
  }
  getAccessRoles(type: string, id: number): Observable<number[]> {
    if (this.accessURL === undefined) {
      this.accessURL = this.config.getBackendResource('resourceAccessRoles');
    }
    return this.http.get<number[]>(`${this.accessURL}/${id}?type=${type}`);
  }
}
